module.exports = __webpack_public_path__ + "img/34.c52bb69c.svg";